export const enVerifyEmail = {
	pending: "Verifying your email address…",
	title: "Email verified.",
	description: "Your email address is confirmed. You can continue where you left off.",
	continue: "Continue",
	failedTitle: "We couldn't verify your email.",
	expired: "This verification link has expired. Request a new one and try again.",
	invalid: "This verification link is not valid. It may already have been used.",
	missingToken: "This link is missing its verification token. Open the link from your email again.",
	resend: "Send a new link",
	resent: "A new verification link is on its way to your inbox.",
	backToLogin: "Back to login",
};
